import { Plus, Minus } from "lucide-react";
import { useState } from "react";
import { motion, AnimatePresence } from "motion/react";

export function FAQ() {
  const faqs = [
    {
      question: "How is Intelisine different from a regular dev agency?",
      answer: "We combine high-end management consulting with top-tier engineering. We don't just take orders; we challenge assumptions and build products that actually solve business problems and generate revenue."
    },
    {
      question: "Do you work with startups or only established companies?",
      answer: "We specialize in SMEs and well-funded startups. We love working with visionary founders who need a technical partner to scale their operations."
    },
    {
      question: "What is your typical project timeline?",
      answer: "Timelines vary based on complexity, but a typical MLP (Minimum Lovable Product) takes 8-12 weeks from discovery to launch. We follow progressive sprint model to get your product to market faster."
    },
    {
      question: "Do you provide post-launch support?",
      answer: "Yes, absolutely. We offer various support and maintenance packages to ensure your digital product continues to run smoothly and evolves with your business."
    },
    {
      question: "What technologies do you specialize in?",
      answer: "We are experts in the modern JavaScript stack (React, Node.js, Next.js), Python for data/AI, and cloud infrastructure (AWS/Azure). We choose the best tool for the job, not just what's trendy."
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-slate-600">Everything you need to know about working with us.</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <FAQItem key={index} faq={faq} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQItem({ faq }: { faq: { question: string; answer: string } }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-6 text-left bg-slate-50 hover:bg-slate-100 transition-colors"
      >
        <span className="font-semibold text-slate-900 text-lg">{faq.question}</span>
        {isOpen ? <Minus className="text-[#FD5750]" /> : <Plus className="text-slate-400" />}
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden bg-white"
          >
            <div className="p-6 text-slate-600 border-t border-slate-100 leading-relaxed">
              {faq.answer}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
